// An image downloads onto an SD card, the card goes into the board's slot, and the board comes alive:
// by itself, or in the drawing that has a power cable, once that is plugged in and its red power
// light is on.
const START = [52, 108], SLOT = [130, 101]
// LEAD holds the empty opening frame before the card arrives.
const LEAD = 1
// HOLD keeps the running board in place for a while before the scene fades and starts over.
const HOLD = 18.25, END = 4.6 + HOLD, CYCLE = LEAD + END + 1.1

const clamp = (x, a = 0, b = 1) => Math.min(b, Math.max(a, x))
const back = t => 1 + 2.7 * Math.pow(t - 1, 3) + 1.7 * Math.pow(t - 1, 2)
const ease = t => t * t * (3 - 2 * t)

function build(svg) {
  const part = name => svg.querySelector(`.${name}`)

  return {
    seat: part('seat'), card: part('card'), arrow: part('arrow'), track: part('track'), progress: part('progress'),
    badge: part('badge'), board: part('board'), led: part('led'), red: part('red'), power: part('power'), wins: [...svg.querySelectorAll('.wins .win')]
  }
}

function draw({seat, card, arrow, track, progress, badge, board, led, red, power, wins}, t) {
  const fade = 1 - clamp((t - END) / 0.6)
  const pop = clamp(t / 0.45), download = clamp((t - 0.6) / 1.6), done = clamp((t - 2.3) / 0.3)
  const slide = ease(clamp((t - 2.9) / 0.9)), alive = power ? 4.8 : 3.8
  const lit = clamp((t - alive) / 0.4) * fade, glow = Math.sin(clamp((t - alive + 0.05) / 0.6) * Math.PI)
  const drop = (download * 2) % 1

  const x = START[0] + (SLOT[0] - START[0]) * slide, y = START[1] + (SLOT[1] - START[1]) * slide
  card.setAttribute('transform', `translate(${x.toFixed(2)} ${y.toFixed(2)}) rotate(${(90 * slide).toFixed(1)}) scale(${(pop > 0 ? back(pop) : 0).toFixed(3)})`)
  card.setAttribute('opacity', fade.toFixed(3))
  seat.setAttribute('opacity', (pop > 0 ? 1 - fade : 1).toFixed(3))

  arrow.setAttribute('transform', `translate(${START[0]} ${(START[1] - 50 + 20 * drop).toFixed(2)})`)
  arrow.setAttribute('opacity', (download > 0 && download < 1 ? Math.sin(drop * Math.PI) : 0).toFixed(3))
  progress.setAttribute('width', (18 * download).toFixed(2))
  track.setAttribute('opacity', (1 - done).toFixed(3))
  progress.setAttribute('opacity', (1 - done).toFixed(3))
  badge.setAttribute('transform', `translate(0 6) rotate(${(-90 * slide).toFixed(1)}) scale(${(done > 0 ? back(done) : 0).toFixed(3)})`)
  badge.setAttribute('opacity', (1 - clamp(slide * 2)).toFixed(3))

  if (power) {
    power.setAttribute('transform', `translate(0 ${(40 * (1 - ease(clamp((t - 3.9) / 0.8)))).toFixed(2)})`)
    power.setAttribute('opacity', (clamp((t - 3.8) / 0.2) * fade).toFixed(3))
    red.style.fill = `color-mix(in srgb, #ff5a4d ${Math.round(clamp((t - 4.7) / 0.2) * fade * 100)}%, #a35a52)`
  }

  board.setAttribute('transform', `translate(186 96) scale(${(1 + 0.045 * glow).toFixed(4)}) translate(-186 -96)`)
  led.style.fill = `color-mix(in srgb, #fff3a6 ${Math.round((power ? 0 : lit) * 100)}%, #3c8f57)`
  wins.forEach((w, i) => {
    const twinkle = 0.12 * lit * Math.sin(t * 1.3 + i * 2.1)
    w.setAttribute('opacity', (0.85 + twinkle).toFixed(3))
  })
}

let Hooks = {}

Hooks['Animations.SdCardImage'] = {
  mounted() {
    const scene = build(this.el)

    // The image arriving on the card, held still.
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return draw(scene, 1.0)

    const start = performance.now()
    const frame = now => {
      draw(scene, ((now - start) / 1000) % CYCLE - LEAD)
      this.raf = requestAnimationFrame(frame)
    }
    this.raf = requestAnimationFrame(frame)
  },

  destroyed() {
    cancelAnimationFrame(this.raf)
  }
}

export {Hooks}
